import React, { Component } from "react";
import PropTypes from "prop-types";
import ReactDOM from "react-dom";
import Animate from "rc-animate";
import createChainedFunction from "rc-util/lib/createChainedFunction";
import classnames from "classnames";
import Notice from "./Notice";
import { loadCss } from "../../ecology9/wea-tools/loadCss";
import WindowFunc from "../../ecology9/wea-tools/window";

let seed = 0;
const now = Date.now();

function getUuid() {
  return `rcNotification_${now}_${seed++}`;
}

class Notification extends Component {
  static propTypes = {
    prefixCls: PropTypes.string,
    transitionName: PropTypes.string,
    animation: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    style: PropTypes.object
  };

  static defaultProps = {
    prefixCls: "rc-notification",
    animation: "fade",
    style: {
      top: 65,
      left: "50%"
    }
  };

  state = {
    notices: []
  };

  getTransitionName() {
    const props = this.props;
    let transitionName = props.transitionName;
    if (!transitionName && props.animation) {
      transitionName = `${props.prefixCls}-${props.animation}`;
    }
    return transitionName;
  }

  add = notice => {
    const key = (notice.key = notice.key || getUuid());
    this.setState(previousState => {
      const notices = previousState.notices;
      if (!notices.filter(v => v.key === key).length) {
        return {
          notices: notices.concat(notice)
        };
      }
    });
  };

  remove = key => {
    this.setState(previousState => {
      return {
        notices: previousState.notices.filter(notice => notice.key !== key)
      };
    });
  };

  render() {
    const props = this.props;
    const noticeNodes = this.state.notices.map(notice => {
      const onClose = createChainedFunction(
        this.remove.bind(this, notice.key),
        notice.onClose
      );
      return (
        <Notice prefixCls={props.prefixCls} {...notice} onClose={onClose}>
          {notice.content}
        </Notice>
      );
    });
    const className = {
      [props.prefixCls]: 1,
      [props.className]: !!props.className
    };
    return (
      <div className={classnames(className)} style={props.style}>
        <Animate transitionName={this.getTransitionName()}>
          {noticeNodes}
        </Animate>
      </div>
    );
  }
}

Notification.newInstance = function newNotificationInstance(
  properties,
  callback
) {
  const { getContainer, ...props } = properties || {};
  let div;
  if (getContainer) {
    div = getContainer();
  } else {
    div = document.createElement("div");
    if (window.setLayoutWindow) {
      window.setLayoutWindow.document.body.appendChild(div);
    } else {
      WindowFunc.getTop().document.body.appendChild(div);
    }
    loadCss();
  }
  let called = false;
  function ref(notification) {
    if (called) {
      return;
    }
    called = true;
    callback({
      notice(noticeProps) {
        notification.add(noticeProps);
      },
      removeNotice(key) {
        notification.remove(key);
      },
      component: notification,
      destroy() {
        ReactDOM.unmountComponentAtNode(div);
        if (!getContainer) {
          if (window.setLayoutWindow) {
            window.setLayoutWindow.document.body.removeChild(div);
          } else {
            WindowFunc.getTop().document.body.removeChild(div);
          }
        }
      }
    });
  }
  ReactDOM.render(<Notification {...props} ref={ref} />, div);
};

export default Notification;



// WEBPACK FOOTER //
// ./_rc-notification-3.0.0/src/Notification.jsx